import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate, useParams } from "react-router-dom";
import { constants } from "../../constants/constants";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { uploadFile } from "../../utils/ApiCalls/Document";
import { getExperienceDataLocation } from "../../utils/ApiCalls/Experience";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import { checkFields } from "../../utils/Validation/checkFields";

import Swal from "sweetalert2";
import { getActivityCategory } from "../../utils/ApiCalls/Mobile/ActivityMasters";
import {
  createShortcuts,
  updateShortCutsData,
} from "../../utils/ApiCalls/Shortcuts";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import UploadFileImageBanner2 from "../Banner/uploadFileImageBanner copy";
import { getImage } from "../../utils/getImages";
import UploadFile from "../fileUpload/uploadFile";
import { addlog } from "../../utils/ApiCalls/Logs";
import { LOG_ACTIONS, LOG_TYPES } from "../../utils/Constant/LogConstant";

const ShortcutsInput = ({ experience }) => {
  const appPages = ["Videos", "Itinerary", "Accounts"];
  const webpages = [
    "Bill of rights",
    "Privacy Policy",
    "Cookie Policy",
    "Terms of Usage",
    "Passage Terms",
    "Terms & Condition",
    "Safety Information",
    // "Contact Us",
  ];

    let slugs = [
    { title: "Bill of rights", slug: "mobile-bill-of-rights" },
    { title: "Privacy Policy", slug: "mobile-privacy-policy" },
    { title: "Cookie Policy", slug: "mobile-cookie-policy" },
    { title: "Terms of Usage", slug: "mobile-terms-of-usage" },
    { title: "Passage Terms", slug: "mobile-passage-terms" },
    { title: "Terms & Condition", slug: "mobile-terms-and-conditions" },
    { title: "Safety Information", slug: "safety-information" },
  ];
  let pageslugs = [
    { title: "Videos", slug: "video" },
    { title: "Itinerary", slug: "Itinerary" },
    { title: "Accounts", slug: "trips-section/link-your-cruise" },
  ];

  const [englishTitle, setEnglishTitle] = useState();
  const params = useParams();
  const [vessel, setVessel] = useState();

  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState();
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState();
  const [image, setImage] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [destinationPath, setDestinationPath] = useState("");
  const [parentCategory, setParentCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [appPage, setAppPage] = useState("");
  const [categories, setCategories] = useState([]);
  const [webPage, setWebPage] = useState("");
  const [externalUrl, setExternalUrl] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [currentLocation, setCurrentLocation] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [showValidationError, setShowValidationError] = useState(false);
  useEffect(() => {
    if (experience) {
      setImage(experience?.icon);
      setDestinationPath(experience?.type);
      setSimplifiedChineseTitle(experience?.simplifiedChineseName);
      setTraditionalChineseTitle(experience?.traditionalChineseName);
      setEnglishTitle(experience?.name);

      if (experience?.type == "category") {
        setParentCategory(experience?.data?.parentCategory);
        setSubCategory(experience?.data?.subCategory);
      } else if (experience?.type == "appPage") {
        setAppPage(experience?.data?.route);
      } else if (experience?.type == "webpage") {
        setWebPage(experience?.data?.webPage);
      } else if (experience?.type == "externalUrl") {
        setExternalUrl(experience?.data?.externalUrl);
      } else if (experience?.type == "pdf") {
        setPdfFile(getImage(experience?.data?.pdfFile));
      }
      setIsActive(experience?.is_active === 1 ? true : false);
    }
  }, [experience]);

  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getAllLocations();
    let vessels = await getVessels();
    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setVessel(
        vessels?.find(
          (item) =>
            item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
        )
      );
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  useEffect(() => {
    if (destinationPath == "category") {
      getCatData();
    }
  }, [destinationPath]);

  const getCatData = async (value) => {
    let data = await getActivityCategory({
      page: 1,
      limit: 10000,
      vessel_id: vessel?.id,
      parent_check: "true",
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setCategories(data.data);
    }
  };
  useEffect(() => {
    if (parentCategory && vessel?.id) {
      setSubCategory("");
      getSubData();
    }
  }, [parentCategory, vessel]);
  const getSubData = async (value) => {
    let data = await getActivityCategory({
      page: 1,
      limit: 10000,
      vessel_id: vessel?.id,
      parent_category: parentCategory,
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setSubCategories(data.data);
    }
  };
  const addData = async (e) => {
    e.preventDefault();
    
    // Validate only the 4 required fields
    let errorMessage = "";
    
    if (!englishTitle || englishTitle.trim() === "") {
      errorMessage = "English shortcut Name is required";
    } else if (!simplifiedChineseTitle || simplifiedChineseTitle.trim() === "") {
      errorMessage = "Simplified Chinese Name is required";
    } else if (!traditionalChineseTitle || traditionalChineseTitle.trim() === "") {
      errorMessage = "Traditional Chinese Name is required";
    } else if (!selectedFile && !image) {
      errorMessage = "Icon is required";
    }
    
    if (errorMessage) {
      setShowValidationError(true);
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: errorMessage,
      });
      return;
    }
    
    setShowValidationError(false);
    
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    
    let data = {};
    if (destinationPath == "category") {
      const categoryData = categories?.find(
        (item) => item.id == parentCategory
      );
      const subCatData = subCategories?.find((item) => item.id == subCategory);
      data = {
        parentCategory: parentCategory,
        subCategory: subCategory,
        parentCategoryName: categoryData?.name,
        parentCategoryNameSC: categoryData?.simplified_chinese_name,
        parentCategoryNameTC: categoryData?.traditional_chinese_name,
        subCategoryName: subCatData?.name,
        subCategoryNameSC: subCatData?.simplified_chinese_name,
        subCategoryNameTC: subCatData?.traditional_chinese_name,
      };
    } else if (destinationPath == "appPage") {
      data = {
        route: appPage,
        slug: pageslugs.find((item) => item.title == appPage)?.slug,
      };
    } else if (destinationPath == "webpage") {
      data = {
        webPage,
        slug: slugs.find((item) => item.title == webPage)?.slug,
      };
    } else if (destinationPath == "externalUrl") {
      data = { externalUrl };
    } else if (destinationPath == "pdf") {
      if (pdfFile) {
        if (typeof pdfFile === "string") {
          data.pdfFile = pdfFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let image = await uploadFile(pdfFile, undefined, null, typeof experience?.data?.pdfFile === 'string' ? experience.data.pdfFile.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);

          data.pdfFile = image?.url;
        }
      } else {
        data.pdfFile = "";
      }
    }
    let dataValues = {
      icon: image,
      vesselId: vessel?.id,
      type: destinationPath,
      data: data,
      is_active: isActive ? 1 : 0,
      name: englishTitle,
      simplifiedChineseName: simplifiedChineseTitle,
      traditionalChineseName: traditionalChineseTitle,
    };
    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.icon = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let image = await uploadFile(selectedFile, undefined, null, typeof experience?.icon === 'string' ? experience.icon.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);

        dataValues.icon = image?.url;
      }
    } else {
      dataValues.icon = "";
    }

    let valid = checkFields(dataValues);
    if (valid) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: valid,
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
    } else {
      try {
        let experienceData;
        if (experience?.id) {
          experienceData = await updateShortCutsData(experience.id, dataValues);
         addlog(
            LOG_ACTIONS.UPDATED,
            LOG_TYPES.Shortcuts,
            {
              id: experience.id,
              title: `Shortcuts ${dataValues.name}, ${vessel?.name}`,
            },
            userDetails.id
          );
        } else {
          experienceData = await createShortcuts(dataValues);
          addlog(
            LOG_ACTIONS.CREATED,
            LOG_TYPES.Shortcuts,
            {
              id: experienceData.id,
              title: `Shortcuts ${dataValues.name}, ${vessel?.name}`,
            },
            userDetails.id
          );
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        if (!experience.id) {
          navigate(`/shore/ship-shortcuts/${params?.vessel}`);
        } else {
          navigate(`/shore/ship-shortcuts/${params?.vessel}`);
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: "Values updated", type: "success" },
          });
        }
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: {
            message: error.message || "Unknown error occurred",
            type: "error",
          },
        });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addData}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="fieldrow">
                      <label className="f_label">English shortcut Name <span className="text-danger">*</span></label>
                      <input
                        className="f_input"
                        type="text"
                        value={englishTitle}
                        onChange={(e) => setEnglishTitle(e.target.value)}
                        required
                      />
                      {showValidationError && (!englishTitle || englishTitle.trim() === "") && (
                        <div className="text-danger" style={{ fontSize: "12px", marginTop: "5px" }}>English shortcut Name is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Name <span className="text-danger">*</span></label>
                      <input
                        className="f_input"
                        type="text"
                        value={simplifiedChineseTitle}
                        onChange={(e) =>
                          setSimplifiedChineseTitle(e.target.value)
                        }
                        required
                      />
                      {showValidationError && (!simplifiedChineseTitle || simplifiedChineseTitle.trim() === "") && (
                        <div className="text-danger" style={{ fontSize: "12px", marginTop: "5px" }}>Simplified Chinese Name is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="f_input"
                        type="text"
                        value={traditionalChineseTitle}
                        onChange={(e) =>
                          setTraditionalChineseTitle(e.target.value)
                        }
                        required
                      />
                      {showValidationError && (!traditionalChineseTitle || traditionalChineseTitle.trim() === "") && (
                        <div className="text-danger" style={{ fontSize: "12px", marginTop: "5px" }}>Traditional Chinese Name is required</div>
                      )}
                    </div>
                  </div>
                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-12"
                    width={40}
                    height={40}
                    image={
                      experience?.icon
                        ? `${constants.MEDIAURL}/${experience?.icon}`
                        : experience?.icon
                    }
                    label={"Icon"}
                    placeholder={"Upload icon"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    mandatory="*"
                    showError={showValidationError}
                  />
                  <Box p={3} className="col-lg-12" mx="auto">
                    <label className="f_label" variant="h6" gutterBottom>
                      Select Destination Path
                    </label>

                    {/* Destination Path Options */}
                    <RadioGroup
                      row
                      value={destinationPath}
                      onChange={(e) => setDestinationPath(e.target.value)}
                    >
                      <FormControlLabel
                        className="f_label"
                        style={{
                          border: "1px solid black",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          borderColor: "gray",
                        }}
                        value="category"
                        control={<Radio />}
                        label="Link to Category"
                      />
                      <FormControlLabel
                        className="f_label"
                        value="appPage"
                        style={{
                          border: "1px solid black",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          borderColor: "gray",
                        }}
                        control={<Radio />}
                        label="Link to APP Page"
                      />
                      <FormControlLabel
                        className="f_label"
                        value="webpage"
                        style={{
                          border: "1px solid black",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          borderColor: "gray",
                        }}
                        control={<Radio />}
                        label="Link to Webpage"
                      />
                      <FormControlLabel
                        className="f_label"
                        value="externalUrl"
                        style={{
                          border: "1px solid black",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          borderColor: "gray",
                        }}
                        control={<Radio />}
                        label="Link to External URL"
                      />
                      <FormControlLabel
                        className="f_label"
                        value="pdf"
                        style={{
                          border: "1px solid black",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          borderColor: "gray",
                        }}
                        control={<Radio />}
                        label="Upload PDF"
                      />
                    </RadioGroup>

                    <Divider sx={{ my: 2 }} />

                    {/* Parent & Sub-Category */}
                    {destinationPath === "category" && (
                      <Box display="flex" gap={2} mb={2}>
                        <FormControl fullWidth>
                          <InputLabel>Parent Category</InputLabel>
                          <Select
                            value={parentCategory}
                            onChange={(e) => setParentCategory(e.target.value)}
                            label="Parent Category"
                          >
                            {categories.map((cat) => (
                              <MenuItem key={cat?.id} value={cat?.id}>
                                {cat?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <FormControl fullWidth disabled={!parentCategory || !subCategories?.length}>
                          <InputLabel>Sub-Category</InputLabel>
                          <Select
                            value={subCategory}
                            onChange={(e) => setSubCategory(e.target.value)}
                            label="Sub-Category"
                          >
                            {parentCategory && subCategories?.length > 0 ? (
                              subCategories?.map((sub) => (
                                <MenuItem key={sub.id} value={sub.id}>
                                  {sub?.name}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="">
                                <em>No sub-categories available</em>
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </Box>
                    )}

                    {/* App Page */}
                    {destinationPath === "appPage" && (
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Select APP Page</InputLabel>
                        <Select
                          value={appPage}
                          onChange={(e) => setAppPage(e.target.value)}
                          label="Select APP Page"
                        >
                          {appPages.map((page) => (
                            <MenuItem key={page} value={page}>
                              {page}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* Webpage */}
                    {destinationPath === "webpage" && (
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Select Webpage</InputLabel>
                        <Select
                          value={webPage}
                          onChange={(e) => setWebPage(e.target.value)}
                          label="Select Webpage"
                        >
                          {webpages.map((page) => (
                            <MenuItem key={page} value={page}>
                              {page}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* External URL */}
                    {destinationPath === "externalUrl" && (
                      <TextField
                        fullWidth
                        label="Enter External URL"
                        value={externalUrl}
                        onChange={(e) => setExternalUrl(e.target.value)}
                        sx={{ mb: 2 }}
                      />
                    )}

                    {/* Upload PDF */}
                    {destinationPath === "pdf" && (
                      <UploadFile
                        className={""}
                        mandatory={""}
                        label={"PDF file"}
                        placeholder={"PDF file"}
                        selectedFile={pdfFile}
                        image={getImage(experience?.data?.pdfFile)}
                        setSelectedFile={(e) => {
                          setPdfFile(e);
                        }}
                        accept="application/pdf"
                      />
                    )}
                  </Box>

                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={(e) => setIsActive(e.target.checked)}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {experience.id ? "Update" : "Add"} Shortcuts
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default ShortcutsInput;
